var TEMPLATE_URL = require('./footer.nav.html');

angular.module('ikeweb.layout').directive('footerNav', function() {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: TEMPLATE_URL,
        link: function($scope) {
            $scope.applicationVersion = require('../../../config').package.version;
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./src/client/components/layout/footer/footer.nav.directive.js
// module id = 460
// module chunks = 0